// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"81":"f6db6ca6","192":"5850c07b","512":"79c278e8","528":"907a98de","667":"e50f18b1","697":"5fd15a11"}[chunkId] + ".chunk.css";
};